{
  "version": 1,
  "asset_id": "988c0831-debb-4bd2-98bd-9f80c985cba9",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/988c0831-debb-4bd2-98bd-9f80c985cba9/silivri-hizli-elektrikci-7-24-dukkan-8.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/988c0831-debb-4bd2-98bd-9f80c985cba9/silivri-hizli-elektrikci-7-24-dukkan-8.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-8.jpg",
  "size": 136253,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:27:00Z"
}
